<template>
  <div
      class="min-h-screen flex items-center justify-center md:bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="w-full" v-bind:style="{maxWidth: '600px'}">

        <div class="flex justify-center">
          <div class="mb-10 w-5/12">
            <YogoIcon></YogoIcon>
          </div>
        </div>

        <div
          v-if="success"
          class="bg-white md:border rounded-md border-gray-200 py-8 md:py-10 sm:px-6 px-4 md:px-8"
        >
        <h2>
          <p>{{ $t('email.YourYogoDemoReady') }}! 🥳</p>
        </h2>

        <div>

          <p>{{ $t('email.Dear') }} {{ first_name }}.</p>
          <br>
          {{ $t('email.YourYogoDemoReady') }}.
          {{ $t('email.PleaseAllowIntroduction') }}
          {{ $t('email.CanLogWithiEmailPassword') }}

          <h3 class="mt-6 mb-2">{{ $t('email.AdminModule') }}</h3>
          {{ $t('email.WhereKeepTrack') }}
          {{ $t('email.CustomersClassesEtc') }}
          <br>

          <a :href="admin_module_dashboard_link" target="_blank">
            <YogoButton
            secondary
            >
              {{ $t('email.GoToAdminModule') }}
            </YogoButton>
          </a>

          <!--Hide the following for USC Admin signups-->
          <template v-if="!is_usc_admin_signup">
            <h3 class="mt-6 mb-2">{{ $t('email.CustomerModule') }}</h3>
            {{ $t('email.WhereBuyRegister') }}
            <br>
            <a :href="frontend_my_profile_link" target="_blank">
              <YogoButton
              secondary
              >
               {{ $t('email.GoToFrontendModule') }}
              </YogoButton>
            </a>

            <h3 class="mt-6 mb-2">{{ $t('email.WebsiteWidget') }}</h3>
            {{ $t('email.ModulesEasilyEmbeded') }}
            {{ $t('email.WayYourCustomers') }}
            {{ $t('email.WidgetIntegration1') }}
            <a :href="admin_module_dashboard_link" target="_blank" class="underline">{{ $t('email.WidgetIntegration2') }}</a>{{ $t('email.WidgetIntegration3') }}

            <h3 class="mt-6 mb-2">{{ $t('email.TeacherModule') }}</h3>
            {{ $t('email.WhereYourTeachers') }}
            {{ $t('email.AlsoWhereStartLiveStream') }}
            <br>
            <a :href="teacher_my_schedule_link" target="_blank">
              <YogoButton
                secondary
              >
                {{ $t('email.GoToTeacherModule') }}
              </YogoButton>
            </a>

            <h3 class="mt-6 mb-2">{{ $t('email.CheckinModule') }}</h3>
            {{ $t('email.CanRunOnTablet') }}
            <br>

            <a :href="checkin_link" target="_blank">
            <YogoButton
              secondary
            >
              {{ $t('email.GoToCheckinModule') }}
            </YogoButton>
            </a>

            <h3 class="mt-6 mb-2">{{ $t('email.NativeApp') }}</h3>
            {{ $t('email.YogoNativeApp') }}
          </template>
        </div>
      </div>

      <div v-if="error"
           class="md:bg-white md:border rounded-md border-gray-200 py-8 md:py-10 sm:px-6 md:px-8">
        <h2 class="mt-6 text-center">
          <p v-if="errorType == 'expired'">{{ $t('login.linkExpired') }}</p>
          <p v-if="errorType == 'invalid'">{{ $t('login.linkInvalid') }}</p>
        </h2>

        <div style="width: 500px; margin: 40px 30px 20px; font-size: 20px">
          <p v-if="errorType == 'expired'">{{ $t('login.linkExpiredComment') }}</p>
          <p v-if="errorType == 'invalid'">{{ $t('login.linkInvalidComment') }}</p>
        </div>

        <button class="btn-primary mt-8 w-full" type="button" v-on:click="goHome">
          {{ $t('login.getFreeDemo') }}
        </button>

      </div>

      <div v-if="loading"
           class="md:bg-white md:border rounded-md border-gray-200 py-8 md:py-10 sm:px-6 md:px-8">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>


    </div>

  </div>
</template>

<script>

import YogoApi from '@/gateways/YogoApi';
import ModalLogo from './ModalLogo';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import YogoButton from "./YogoButton.vue"
import YogoIcon from "../graphics/icons/YogoIcon.vue"

export default {
  data() {
    return {
      id: '',
      clientName: '',
      userName: '',
      email: '',
      success: false,
      error: false,
      errorMessage: '',
      errorType: '',

      color: '#5bc0de',
      size: '45px',
      margin: '2px',
      radius: '2px',
      loading: false,

      first_name: '',
      admin_module_dashboard_link: '',
      frontend_my_profile_link: '',
      teacher_my_schedule_link: '',
      checkin_link: '',
      is_usc_admin_signup: false,

      styleObjectH3: {
        wordBreak: 'break-all',
        marginTop: '20px',
      },
    };
  },
  components: {
    ModalLogo,
    ClipLoader,
    YogoButton,
    YogoIcon
  },
  created: async function () {
    if (this.$route.query.token) {
      console.log("query = ", this.$route.query);
      const token = this.$route.query.token;
      this.loading = true;
      const response = await YogoApi.get(`/client-signing-up/confirm?token=${token}`);

      if (response.error) {
        this.error = true;
        this.success = false;
        this.loading = false;
        if (response.error == "The provided token is expired.") {
          this.errorType = "expired";
        } else if (response.error == "The provided token is invalid, or already used up." || response.error == "This email address already exits.") {
          this.errorType = "invalid";
        }
        return;
      }

      console.log("response = ", response);
      this.first_name = response.first_name;
      this.admin_module_dashboard_link = response.admin_module_dashboard_link;
      this.frontend_my_profile_link = response.frontend_my_profile_link;
      this.teacher_my_schedule_link = response.teacher_my_schedule_link;
      this.checkin_link = response.checkin_link;
      this.is_usc_admin_signup = response.is_usc_admin_signup;

      await this.$store.dispatch('appSettings/update', {locale: response.locale});

      console.log("first_name = ", this.first_name);
      console.log("admin_module_dashboard_link = ", this.admin_module_dashboard_link);
      console.log("teacher_my_schedule_link = ", this.teacher_my_schedule_link);
      console.log("teacher_my_schedule_link = ", this.teacher_my_schedule_link);
      console.log("checkin_link = ", this.checkin_link);

      this.loading = false;
      this.success = true;
      this.error = false;

    }
  },
  methods: {
    goHome: function (event) {
      this.$router.push({ name: 'Signup' });
    },

  },
};

</script>

<style lang="stylus" scoped="true">

label
  display block
  height 100%

.router-link-active
  background none

input.error
  border-color: red;

</style>
